import { atom } from 'recoil';

export type TIsProjectsSavedMap = {
  [key: string]: boolean;
};

export const isProjectsSavedMap = atom<TIsProjectsSavedMap>({
  key: 'projects',
  default: {} as TIsProjectsSavedMap,
});
